import React from 'react';
import {useParams} from 'react-router-dom';
import useCondition from '../../../../useCondition';
import useFilterModalContext from '../../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {useSalesforceDealRecordTypesQuery} from 'api';
import SearchCondition from './SearchCondition';

export default () => {
  const {poolId} = useParams<{
    poolId: string;
  }>();

  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  const {data: {salesforceDealRecordTypes = []} = {}} =
    useSalesforceDealRecordTypesQuery({
      variables: {
        poolId,
      },
      skip: !poolId,
    });

  const recordType = salesforceDealRecordTypes.find(
    (recordType) => recordType.id === condition?.salesforceDealRecordTypeId,
  );

  if (
    !condition.hasSalesforceDeal &&
    !condition?.salesforceDealRecordTypeId &&
    !(condition?.salesforceDealSearchConditions?.length > 0)
  ) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">商談</h4>
        <button
          onClick={() => setFilterType('salesforceDeal')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() =>
            setCondition({
              hasSalesforceDeal: false,
              salesforceDealRecordTypeId: '',
              salesforceDealSearchConditions: [],
            })
          }
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-c-light">レコードタイプ：</span>
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {recordType?.name}
        </span>
      </div>
      {condition.salesforceDealSearchConditions?.length > 0 &&
        condition.salesforceDealSearchConditions?.map((searchCondition, i) => (
          <SearchCondition key={i} searchCondition={searchCondition} />
        ))}
    </div>
  );
};
